import { isNewbuildingSelector } from './offer';
import { IState } from '../../store';
import { getIsSaleByOffer } from '../../utils/deal_type';
import { isSuburbanOfferFromBuilder } from '../../utils/suburban';
import { getOffer } from '../newObject';
import { selectIsNewbuildingPremiumRate } from '../newbuildingPremiumRate';

export const selectIsMortgageBannerAvailable = (state: IState) => {
  const offer = getOffer(state);
  const isSale = getIsSaleByOffer(offer);
  const isNewBuilding = isNewbuildingSelector(state);
  const isPremiumNewbuilding = selectIsNewbuildingPremiumRate(state);

  const isNewbuildingBannerDisabled = isSale && isNewBuilding && isPremiumNewbuilding;

  return !isSuburbanOfferFromBuilder(offer) && !isNewbuildingBannerDisabled;
};
